import { z } from 'zod';

export const readNotificationSchema = z.object({
  notification_id: z.string().min(1),
});

export type ReadNotificationPayload = z.infer<typeof readNotificationSchema>;
